<template>
  <modal wrapperClasses="passcode">
    <div slot="header">
      <h3>{{ welcomeMessage }}</h3>
    </div>
    <div slot="body" class="modal-content">
      <div>
        <b>log in</b>
      </div>
      <div class="pin-code-explanation">
        enter your log in code below to proceed
      </div>
      <passcode-input
        :length-limitation="4"
        :passcode.sync="passcode"
        autocomplete="one-time-code" />
      <div v-if="error" class="error">{{ error }}</div>
    </div>
    <div slot="modal-backdrop-footer">
      <div class="footer-legal-notice">
        <p>
          Message frequency may vary. Message & Data Rates May apply. Want to unsubscribe? Reply <b>STOP</b> to your text message. Need help? Reply <b>HELP</b> to your text message. No customer information is transmitted or shared through these text message notifications. No mobile information will be shared with third parties for marketing purposes.
        </p>
        <p>
          © {{ new Date().getFullYear() }} {{ merchantDbaName }}. Privacy Policy (<a href="https://my.securelinkit.com/privacy" target="_blank">https://my.securelinkit.com/privacy</a>) | Terms and Conditions (<a href="https://my.securelinkit.com/terms_conditions" target="_blank">https://my.securelinkit.com/terms_conditions</a>)
        </p>
      </div>
    </div>
    <template #action>
      <div v-if="!showResend" class="modal-click-action">
        <div class="forgot-code-block">
          forgot code?
        </div>
        <button @click="clickedResend(1.5 * 60 * 1000)" :disabled="logInCodeHasBeenSent" :class="{ disabled: logInCodeHasBeenSent }">{{ sendLogInCodeLabel }}</button>
      </div>
      <div v-if="showResend" class="modal-footer">
        <div>didn't get the code?</div>
        <div @click="clickedResend(10 * 60 * 1000)" v-if="!hasBeenResent" class="link">resend</div>
        <div v-if="hasBeenResent">thank you for your request. you should receive your log in code within a few minutes</div>
      </div>
    </template>
    <div slot="footer" class="links">
      <a href="/terms_conditions" target="_blank" rel="noreferrer noopener">terms and conditions</a>
      <a href="/privacy" target="_blank" rel="noreferrer noopener">privacy policy</a>
    </div>
  </modal>
</template>

<script>
  import Modal from '../../components/shared/Modal'
  import { passcodeAPI } from "../../services/api/passcode"
  import PasscodeInput from '../../components/shared/PasscodeInput'

  export default {
    props: {
      memberAccessCode: Number,
      merchantDbaName: String
    },

    name: 'EasyCodeFlowModal',

    data() {
      return {
        error: '',
        hasBeenResent: false,
        logInCodeHasBeenSent: false,
        passcode: '',
        showResend: false
      }
    },

    components: {
      Modal,
      PasscodeInput
    },

    computed: {
      encodedSecureLinkId(){
        return this.$route.params.id
      },

      sendLogInCodeLabel(){
        return !this.logInCodeHasBeenSent ? "send me my log in code" : "sending log in code now"
      },

      welcomeMessage(){
        return !this.merchantDbaName ? "welcome" : "welcome to " + this.merchantDbaName
      }
    },

    methods: {
      submitLogInCode(){
        if(!this.passcode) return this.showInvalidLogInCodeErr()
        return  passcodeAPI.getCheckLogInCode(
                  this.encodedSecureLinkId,
                  this.passcode
                )
                .then(data => {
                  if(!!data.redirect_url){
                    location.replace(data.redirect_url)
                  }else {
                    this.$router.push({
                      name: 'Stashboard',
                      params: {
                        id: this.encodedSecureLinkId,
                        anyLinks: data.any_link_extensions,
                        appStoreUrl: data.app_store_url,
                        content: data.sms_content,
                        extensionType: data.type,
                        googlePlayUrl: data.google_play_url,
                        merchantName: data.merchant_name,
                        merchantWebsiteUrl: data.website,
                        stashboardHeaders: data.stashboard_headers,
                        stashboardMedia: data.stashboard_media,
                        urlButton: data.url,
                        urlImage: data.mms_cdn_link,
                        urlLogo: data.merchant_logo?.url,
                      }
                    })
                  }
                })
                .catch(error => {
                  this.showInvalidLogInCodeErr()
                  setTimeout(() => {
                    this.passcode = ''
                  }, 1000);
                })
      },

      clearError(){
        return this.error = ''
      },

      clickedResend(duration){
        this.logInCodeHasBeenSent = true;
        if(this.showResend) this.hasBeenResent = true;
        // We show the button "resend" after the duration expires
        setTimeout(() => {
          if(this.showResend) this.hasBeenResent = !this.hasBeenResent
          this.showResend = true
        }, duration);
        this.sendLogInCode();
      },

      sendLogInCode(){
        return passcodeAPI.postSendLogInCode(this.encodedSecureLinkId).then(data => this.$emit('update:memberAccessCode', data.id));
      },

      showInvalidLogInCodeErr(){
        this.error = 'must enter valid code';
      }
    },

    watch: {
      passcode(value){
        if(value.length === 4) this.submitLogInCode()
      }
    }
  }

</script>
